export enum Transparency {
  Opaque = 1, // 予定あり
  Transparent = 2, // 予定なし
}

export enum TransparencyText {
  Opaque = 'opaque', // 予定あり
  Transparent = 'transparent', // 予定なし
}
